import * as React from 'react'
import * as Sentry from '@sentry/react'
import * as ReactDOM from 'react-dom'
import * as ReactRouterDom from 'react-router-dom'
import * as ReactComponents from '@monthio/react-components'
import * as Notistack from 'notistack'
import * as StyledComponents from 'styled-components'
import * as Formik from 'formik'
import * as RxJS from 'rxjs'

window.SentryReact = Sentry
window.React = React
window.ReactDOM = ReactDOM
window.ReactRouterDom = ReactRouterDom
window.ReactComponents = ReactComponents
window.Notistack = Notistack
window.StyledComponents = StyledComponents
window.Formik = Formik
window.Formik = Formik
window.RxJs = RxJS

export default {}
